import type { EmitFn } from 'vue'
import type { InputFieldEvents } from '~/interfaces/InputFieldEvents'

export const createStringInputHandlers = (
  emit: EmitFn<InputFieldEvents<string>>
): {
  handleUpdate: (value: string | number | undefined) => void
  handleBlur: () => void
} => ({
  handleUpdate: (value: string | number | undefined): void => {
    emit('update:modelValue', String(value ?? ''))
  },
  handleBlur: (): void => {
    emit('blurred')
  }
})
